export enum EnvTypeENUM {
  development = 'development',
  production = 'production',
}

export const envType = process.env.REACT_APP_ENV || process.env.NODE_ENV || EnvTypeENUM.development;
export const isDev = envType === EnvTypeENUM.development;
export const isProd = envType === EnvTypeENUM.production;

const config = {
  apiUrl: 'https://labour.fusion-tech.pro/',
  maxNumberOfAttempts: 10,
  protocol: 'http://',
  domain: 'localhost:3000',
};

// eslint-disable-next-line default-case
switch (envType) {
  case EnvTypeENUM.development:
    config.apiUrl = 'https://stage.cms.labourtheapp.com/';
    config.protocol = 'https://';
    config.domain = 'https://stage.cms.labourtheapp.com/';
    break;
  case EnvTypeENUM.production:
    config.apiUrl = 'https://cms.labourtheapp.com/';
    config.protocol = 'https://';
    config.domain = 'https://cms.labourtheapp.com/';
    break;
}

export default config;
